import { useShallow } from 'zustand/react/shallow'

import { RequestMode } from '../../../utils/constants'
import useAppStore from '../stores/store'

export const useRequestMode = () => {
  const { highlightedText, reviewSuggestions } = useAppStore(
    useShallow((s) => ({
      highlightedText: s.highlightedText,
      reviewSuggestions: s.reviewSuggestions,
    }))
  )
  return !highlightedText?.text
    ? RequestMode.INSERT
    : reviewSuggestions
      ? RequestMode.REVISE
      : RequestMode.EDIT
}
